(function () {
  const modal = document.querySelector('product-modal');
  if (!modal || modal.dataset.sliderReady) return;
  modal.dataset.sliderReady = 'true';

  const track = modal.querySelector('.product-media-modal__content');
  const dialog = modal.querySelector('.product-media-modal__dialog');
  if (!track || !dialog) return;

  const desktop = window.matchMedia('(min-width: 750px)');
  const chevron = (points) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="${points}"></polyline></svg>`;

  const makeArrow = (direction, label, points) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `gallery-slider-arrow gallery-slider-arrow--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = chevron(points);
    // Flux's media modal hides itself on any mouse pointerup inside it
    // ("click anywhere to close"); keep our controls from triggering that.
    ['pointerup', 'pointerdown', 'click'].forEach((type) =>
      button.addEventListener(type, (event) => event.stopPropagation())
    );
    button.addEventListener('click', () => move(direction === 'next' ? 1 : -1));
    dialog.appendChild(button);
    return button;
  };

  const prev = makeArrow('prev', 'Previous image', '15 18 9 12 15 6');
  const next = makeArrow('next', 'Next image', '9 18 15 12 9 6');

  const counter = document.createElement('div');
  counter.className = 'gallery-slider-counter';
  counter.addEventListener('pointerup', (event) => event.stopPropagation());
  counter.setAttribute('aria-live', 'polite');
  dialog.appendChild(counter);
  const total = track.children.length;

  function move(step) {
    track.scrollBy({ left: step * track.clientWidth, behavior: 'smooth' });
  }

  function update() {
    const max = track.scrollWidth - track.clientWidth - 1;
    prev.disabled = track.scrollLeft <= 0;
    next.disabled = track.scrollLeft >= max;
    const index = Math.round(track.scrollLeft / track.clientWidth) + 1;
    counter.textContent = `${Math.min(Math.max(index, 1), total)} / ${total}`;
  }

  track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });

  modal.addEventListener('keydown', (event) => {
    if (!desktop.matches || !modal.hasAttribute('open')) return;
    if (event.key === 'ArrowRight') move(1);
    if (event.key === 'ArrowLeft') move(-1);
  });

  function jumpToOpened() {
    // Flux's ProductModal resets scrollLeft after showing; put the slider on the
    // image the opener asked for (data-media-id) once that has happened.
    const wanted = modal.openedBy && modal.openedBy.getAttribute('data-media-id');
    const target = wanted && track.querySelector(`[data-media-id="${wanted}"]`);
    if (target) track.scrollLeft = target.offsetLeft - track.offsetLeft;
    update();
  }

  new MutationObserver(() => {
    if (!modal.hasAttribute('open')) return;
    window.requestAnimationFrame(() => window.requestAnimationFrame(jumpToOpened));
  }).observe(modal, { attributes: true, attributeFilter: ['open'] });
})();
